import WaitingLoanResponse from "../../assets/Animations/WaitingLoanResponseSpinnerTheme.svg";
import { getMode } from "../../utils/getMode";

export const defaultLogoSize = 110;

export const headerHeights = () => {
  const mode = getMode();

  if (mode === "embedded") {
    return {
      logo: {
        mobile: 42,
        desktop: 54,
      },
      logoContainerHeight: {
        mobile: 45,
        desktop: 50,
      },
      logoContainerHeightForCalculation: {
        mobile: 49,
        desktop: 64,
      },
      progressBar: { mobile: 10, desktop: 20 },
      progressBarForCalculation: {
        mobile: 42,
        desktop: 52,
      },
    };
  }

  return {
    logo: {
      mobile: 55,
      desktop: 60,
    },
    logoContainerHeight: {
      mobile: 45,
      desktop: 60,
    },
    logoContainerHeightForCalculation: {
      mobile: 69,
      desktop: 84,
    },
    progressBar: { mobile: 20, desktop: 30 },
    progressBarForCalculation: {
      mobile: 52,
      desktop: 62,
    },
  };
};

export const ANIMATIONS = {
  WAITING_LOAN_RESPONSE: {
    id: "WAITING_LOAN_RESPONSE",
    src: WaitingLoanResponse,
  },
};
export const assetTypes = {
  HOME_IMPROVEMENT: "home_improvement",
  UTILITIES_SUPPLY: "utilities_supply",
  HEALTH: "health",
  EDUCATION: "education",
  TRAVEL: "travel",
  MINIMAL_AUTO: "minimal_auto",
  AUTO: "auto",
  OTHER: "other",
  CREDIT_LINE: "credit_line",
  CARD: "card",
  MINIMAL: "minimal",
};
export const ONBOARDING_FULFILLED_BY_TYPES = {
  MERCHANT_POS: "merchant_pos",
  BORROWER_POS: "borrower_pos",
  BORROWER_ONLINE: "borrower_online",
  CLIENT_SIDE_KYC_SIGNATURE: "client_side_kyc_signature",
};

export const ONBOARDING_PARTICIPANT_ROLES = {
  BORROWER: "borrower",
  CO_BORROWER: "co_borrower",
  GUARANTOR: "guarantor",
};

export const loanTypeIcons = {
  undefined: assetTypes.OTHER,
  education: assetTypes.EDUCATION,
  home_improvement: assetTypes.HOME_IMPROVEMENT,
  utilities_supply: assetTypes.UTILITIES_SUPPLY,
  health: assetTypes.HEALTH,
  travel: assetTypes.TRAVEL,
  auto: assetTypes.AUTO,
  other: assetTypes.OTHER,
};

export const STEP_GROUP_IDS = {
  KycManual: "KycManual",
  KycAutomatic: "KycAutomatic",
  ClientSideSignatureKycAutomatic: "ClientSideSignatureKycAutomatic",
  NieEuAdditionalData: "NieEuAdditionalData",
  AdditionalData: "AdditionalData",
  ProfessionalData: "ProfessionalData",
  DeclaredIncomeOnConditions: "DeclaredIncomeOnConditions",
  DeclaredIncome: "DeclaredIncome",
  SummaryAndAdjustLoan: "SummaryAndAdjustLoan",
  AddParticipantToLoan: "AddParticipantToLoan",
  VideoId: "VideoId",
  VideoIdResult: "VideoIdResult",
  Card: "Card",
  DocumentIdVerification: "DocumentIdVerification",
};
